<template>
  <div class="box-sin-aplicar-2">
    <div
      style="width:30px;display:flex;justify-content:center;align-items:center;margin-right: 4px;"
    >
      # {{ item.num_camiseta }}
    </div>
    <b-avatar style="flex:1" size="52" :src="item.foto_jug" />
    <small
      style="margin-left: 3px; flex:3;display:flex;justify-content:center;align-items:center"
      >{{ item.nombreCom }}</small
    >
    <div
      v-if="isGol"
      style="color:white;background-color: rgb(74, 73, 73); width:30px;display:flex;justify-content:center;align-items:center;margin-right: 4px;"
    >
      {{ item.cantidad }}
    </div>
  </div>
</template>
<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
  },
  props: {
    item: Object,
    label: String,
    isGol: Boolean,
  },
}
</script>
<style lang="scss">
.box-sin-aplicar-2 {
  background-color: rgb(248, 244, 244);
  width: auto;
  height: auto;
  margin-bottom: 12px;
  padding: 2px;
  border-radius: 4px;
  display: flex;
}
</style>
